import React, { useState } from "react";
import styled from "styled-components";
import {
    AiOutlineUsergroupAdd,
    AiOutlineLogout,
    AiOutlineAccountBook,
    AiOutlineProject,
    AiOutlineTool,
    AiOutlineDown
} from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../services/authService";
import LogoutPopup from "./ui/LogoutPopup";

function CashierSidebar({ setCurrentPage }) {
    const [currentLink, setCurrentLink] = useState("Invoice");
    const [isFinanceDropdownOpen, setIsFinanceDropdownOpen] = useState(true);
    const [showLogoutPopup, setShowLogoutPopup] = useState(false);
    const navigate = useNavigate();

    const handlePageChange = (page) => {
        setCurrentLink(page);
        setCurrentPage(page);
    };

    // Show logout confirmation popup
    const confirmLogout = () => {
        setShowLogoutPopup(true);
    };

    // Handle the actual logout
    const handleLogout = () => {
        logoutUser();
        navigate("/login");
    };

    return (
        <>
            <SidebarContainer>
                <div className="top">
                    <div className="brand">
                        <span>W. Thomas and Sons</span>
                        <div className="role-badge">Cashier Portal</div>
                    </div>
                    <div className="links">
                        <ul>
                            {/* Finance Dropdown */}
                            <li
                                className={`dropdown ${isFinanceDropdownOpen ? "open" : ""}`}
                                onClick={() => setIsFinanceDropdownOpen(!isFinanceDropdownOpen)}
                            >
                                <AiOutlineAccountBook />
                                <span>Finance</span>
                                <AiOutlineDown className={`dropdown-arrow ${isFinanceDropdownOpen ? "open" : ""}`} />
                            </li>

                            {isFinanceDropdownOpen && (
                                <ul className="submenu">
                                    <li
                                        className={currentLink === "Invoice" ? "active" : ""}
                                        onClick={() => handlePageChange("Invoice")}
                                    >
                                        <AiOutlineProject />
                                        <span>Invoice</span>
                                    </li>
                                    <li
                                        className={currentLink === "Repair" ? "active" : ""}
                                        onClick={() => handlePageChange("Repair")}
                                    >
                                        <AiOutlineTool />
                                        <span>Repairs</span>
                                    </li>
                                </ul>
                            )}

                            {/* Customers Section */}
                            <li
                                className={currentLink === "Customers" ? "active" : ""}
                                onClick={() => handlePageChange("Customers")}
                            >
                                <AiOutlineUsergroupAdd />
                                <span>Customers</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Logout button */}
                <div className="logout" onClick={confirmLogout}>
                    <AiOutlineLogout />
                    <span>Logout</span>
                </div>
            </SidebarContainer>

            {/* Logout Confirmation Popup */}
            {showLogoutPopup && (
                <LogoutPopup
                    onConfirm={handleLogout}
                    onClose={() => setShowLogoutPopup(false)}
                />
            )}
        </>
    );
}

export default CashierSidebar;

const SidebarContainer = styled.section`
    position: fixed;
    left: 0;
    top: 0;
    background-color: black;
    height: 100vh;
    width: 18vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 2rem 0;
    gap: 0.6rem;
    overflow-y: auto;
    transition: all 0.3s ease-in-out;

    .top {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 1rem 0;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;

        .brand {
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 0.4rem;
            padding: 1rem 0;

            span {
                font-size: 1.2rem;
                font-weight: bold;
                color: white;
                white-space: nowrap;
            }

            .role-badge {
                font-size: 0.8rem;
                color: #4A90E2;
                background-color: rgba(74, 144, 226, 0.1);
                padding: 4px 10px;
                border-radius: 4px;
                margin-top: 5px;
            }
        }
    }

    .links {
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 2rem;

        ul {
            list-style-type: none;
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 0;
            gap: 0.5rem;

            li {
                padding: 0.6rem 1.5rem;
                margin: 5px 15px;
                border-radius: 0 10px 10px 0;
                cursor: pointer;
                transition: background 0.3s, transform 0.2s;
                display: flex;
                align-items: center;
                gap: 1rem;
                font-size: 1rem;
                font-weight: 500;
                background-color: black;
                color: white;

                &:hover {
                    background-color: #333;
                    transform: scale(1.02);
                }

                &.active {
                    background-color: white;
                    color: black;
                    font-weight: bold;
                }

                &.dropdown {
                    justify-content: space-between;

                    .dropdown-arrow {
                        transition: transform 0.3s ease;

                        &.open {
                            transform: rotate(180deg);
                        }
                    }
                }
            }

            .submenu {
                margin-left: 20px;

                li {
                    padding: 0.5rem 1rem;
                    margin: 3px 15px;
                }
            }
        }
    }

    .logout {
        padding: 0.8rem 2rem;
        cursor: pointer;
        background-color: white;
        border-radius: 8px;
        text-align: center;
        font-weight: bold;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin: 1rem;

        &:hover {
            background-color: #f0f0f0;
        }
    }
`;